
window.tscUtil = window.tscUtil || {};
window.tscUtil.throttle = function (func, delay) { // trailing call variety
  'use strict';
  var currentlyThrottled = false;
  return function () {
    var args = arguments;
    var context = this;
    if (!currentlyThrottled) {
      currentlyThrottled = setTimeout(function () {
        currentlyThrottled = false;
        func.apply(context, args);
      }, delay);
    }
  };
};

// Generates object with key/value pairs of QueryString parameters.
// If there are duplicate keys, values are stored as an array.
window.tscUtil.getUrlParams = function () {
  'use strict';
  var match;
  var result = {};
  var plus = /\+/g;
  var search = /([^&=]+)=?([^&]*)/g;
  var query = window.location.search.substring(1);
  var decode = function (s) {
    return decodeURIComponent(s.replace(plus, ' '));
  };

  while ((match = search.exec(query)) !== null) {
    var key = decode(match[1]);
    if (key in result) {
      if (!Array.isArray(result[key])) {
        result[key] = [result[key]];
      }
      result[key].push(decode(match[2]));
    } else {
      result[key] = decode(match[2]);
    }
  }
  return result;
};

/*  how to use:
    var formatter = tscUtil.currencyFormatter('9.876.543,21 €', 9876543.21);
    formatter(1234567.8) === '1.234.567,80 €';

    assumptions made:
    * values to be formatted will be less than the example value
    * values to be formatted will be positive
    * currencies to format will either be whole units or units with hundreths (cents)
      * like '¥1,234' or '1.234,00 €'
*/
window.tscUtil.currencyFormatter = (function () {
  'use strict';

  var currencyPattern = /^(\D*)(\d(?:.+\d)?)(\D*)$/;
  var onlyDigits = /\d/g;
  var digit = /^\d$/;
  var zeros = ['0','0'];

  var roundNumberToString = function (value) {
    return ('' + Math.round(value)).match(onlyDigits).reverse();
  };

  var decimalNumberToString = function (value) {
    var numbers = roundNumberToString(value * 100);
    return numbers.length < 3 ? numbers.concat(zeros).slice(0, 3) : numbers;
  };

  var createFormatter = function (formattedExample, reverseNumbers) {
    var match = formattedExample.match(currencyPattern);
    var leftSymbol = match[1];
    var formattedContent = match[2];
    var rightSymbol = match[3];
    var formattedNumbers = formattedContent.split('').reverse();

    return function (value) {
      var numbers = reverseNumbers(value);
      var offset = 0;
      var formatted = numbers.reduce(function (result, n, i) {
        var formattedN = formattedNumbers[i + offset] || '';
        if (digit.test(formattedN)) {
          return n + result;
        } else {
          offset += 1;
          return n + formattedN + result;
        }
      }, '');

      return leftSymbol + formatted + rightSymbol;
    };
  };

  return function (example, exampleValue) {
    var roundNumberformatter = createFormatter(example, roundNumberToString);
    var withDecimalsFormatter = createFormatter(example, decimalNumberToString);
    return example === withDecimalsFormatter(exampleValue) ? withDecimalsFormatter : roundNumberformatter;
  };
}());
